define((require) => {
    "use strict";

    const Configuration = require("shared/services/Configuration");
    const noop = () => {};

    /**
     * jQuery AJAX transport for IE9 cross-domain requests.
     *
     * <p>IE9 requires cross-domain requests to use the XDomainRequest object. See
     * http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
     * for its many limitations.</p>
     *
     * <p><b>CAVEAT:</b>: for this hook to be called, there must be additional Ajax options specified such as content
     * type, data type, etc. Simply supplying an url for a GET request, for example, will result in a "No Transport"
     * error before this hook is called. </p>
     *
     * <p>Loosely based on https://github.com/jaubourg/ajaxHooks/blob/master/src/xdr.js, but with extensions to support
     * all of our required functionality.</p>
     *
     * @author Bruce Mackenzie Nielsen
     * @class XDomainRequestTransport
     */
    return function(options) {
        // Don't return anything if we shouldn't handle this request
        if (!options.crossDomain || !options.async) {
            return undefined;
        }

        // Set the timeout
        if (options.timeout) {
            options.xdrTimeout = options.timeout;
            delete options.timeout;
        }

        let xdr;
        return {
            send(headers, complete) {
                let method = options.type;
                let data = options.hasContent ? options.data : null;

                // XDomainRequest only supports GET and POST, and we can't set custom headers. So for requests to our
                // API, we convert everything to POST and send some metadata along with the request payload.
                if (options.url.indexOf(Configuration.adminApiBaseUrl) === 0) {
                    method = "POST";

                    // Wrap the data with the metadata
                    const wrappedData = {
                        metadata: {
                            contentType: options.contentType,
                            method: options.type,
                            headers
                        }
                    };

                    // The data is effectively double-stringified, which is on purpose: it's easiest to peel off the
                    // metadata layer first on the backend, then treat the payload as a raw JSON string
                    if (data) {
                        wrappedData.data = data;
                    }

                    data = JSON.stringify(wrappedData);
                }

                // Completion callback
                function callback(status, statusText, responses, responseHeaders) {
                    xdr.onload = xdr.onerror = xdr.ontimeout = noop;
                    xdr = undefined;
                    complete(status, statusText, responses, responseHeaders);
                }

                xdr = new XDomainRequest();

                // Attach event handlers
                xdr.onload = function() {
                    callback(200, "OK", {text: xdr.responseText}, `Content-Type: ${xdr.contentType}`);
                };
                xdr.onerror = function() {
                    callback(404, "Not Found");
                };
                xdr.onprogress = function() {};
                xdr.ontimeout = function() {
                    callback(0, "timeout");
                };
                xdr.timeout = options.xdrTimeout || Number.MAX_VALUE;

                // Send the request
                xdr.open(method, options.url);
                xdr.timeout = options.xdrTimeout || Number.MAX_VALUE; // Seems sometimes IE9 removes the timeout after open
                xdr.send(data);
            },
            abort() {
                if (xdr) {
                    xdr.onerror = noop;
                    xdr.abort();
                }
            }
        };
    };
});



// WEBPACK FOOTER //
// ./src/shared/util/XDomainRequestTransport.js